export enum EProjectPlusPagesType {
  LIVE = 'LIVE',
  SHIPPING_LOG = 'SHIPPING_LOG',
  RANKING = 'RANKING',
  SHARED_SHIPPING_LOG = 'SHARED_SHIPPING_LOG',
  TRUCK_LOG = 'TRUCK_LOG',
}
